export default __webpack_public_path__ + "static/media/AllanCampopiano.6409af45.jpeg";